
if(typeof FN == 'undefined') FN = {};

FN.gitCoffee = {
  contentType: false,
  showImage: function(){
    setTimeout(function(){
      $('#sticker svg').css({'opacity': '1.0'});
    }, 100);
    setTimeout(function(){
      $('#sticker #sticker-shadow, #sticker #sticker-background').css({'opacity': '1.0'});
    }, 1500);
  },
  showNewsletterSignup: function(){
    $('.newsletter-form').show();
    $('.newsletter-form input[type="text"]').focus();
    $('.store-content__wrapper .button-wrapper:last-of-type').css({'margin-bottom': '4em'});
  },
  showStickerForm: function(){
    $('.button--stickersignup-revealer').hide();
    $('.newsletter-form').show();
    $('.store-content__stickers__address').show().focus();
  },
  toggleContentType: function(){
    FN.gitCoffee.contentType = (FN.helpers.getURLParameterByName('type') === 'stickers') ? 'stickers' : 'default';
    if(FN.gitCoffee.contentType === 'stickers' && $('.store-content__stickers').length == 1){
      $('.store-content__stickers').show();
    }else{
      $('.store-content__signup').show();
    }
  },
  sendTicket: function(data, options){
    $('input[type="submit"]').attr('disabled', 'disabled');
    var requestData = { 'message': options.dataPostalAddress,
                        'subject': 'Git Push Coffee Me - Stickers',
                        'email': options.dataEmail,
                        'name': 'Sticker Participant',
                        'category': 'Sales Issue'
                      };
    var requestURL = FN.config.urls.ticket;
    FN.remoteRequest.sendRequest(requestURL, requestData, {'responseContainer':false});
  }
};



FN.popupConfig.addPopupConfig({
  'id': 'fn-popup_incentive_gitpushcoffee',
  'type': 'modal',
  'active': true,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onClick',
    'selector': '.button--incentive_gitpushcoffee',
    'showOnlyOnce': false
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Download the Wallpaper<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">Get a set of awesome wallpapers for your desktop!</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/specialsites/git-push-coffee-me/popup_gitpushcoffee.png" /></span>',
      'action-button': 'Get the Wallpaper',
      'signup-medium': 'tower-blog',
      'signup-URI': 'fn-popup_incentive_gitpushcoffee',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the wallpaper and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'collectConsent': true},
        { 'id': 'incentive_gitcoffee', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    }
  ]
});





$(document).ready(function(){
  /*********** Configure Analytics Event Tracking */
  var micrositeAnalyticsEvents = [
    /* Newsletter Subscription */
    { 'config': { 'selector': '.newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'may-the-fork' }
    },
    /* Page Links */
    { 'config': { 'selector': '.button--store.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'may-the-fork/stuff-store' }
    },
    { 'config': { 'selector': '.social-button--about.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'may-the-fork/tower-website' }
    },
    /* Social Share */
    { 'config': { 'selector': '.social-button--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'may-the-fork/twitter' }
    },
    { 'config': { 'selector': '.social-button--facebook.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'may-the-fork/facebook' }
    },
    { 'config': { 'selector': '.social-button--linkedin.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'may-the-fork/linkedin' }
    },
    /* Content Downloads */
    { 'config': { 'selector': '.content-download-link.analytics--click' },
      'event':  { 'eventCategory': 'content', 'eventAction': 'download', 'eventLabelSuffix': 'git-coffee-wallpapers' }
    }
  ];
  FN.analytics.addConfiguredEvents(micrositeAnalyticsEvents);


  /*********** prefill "source[OS]" value in newsletter forms */
  if($('input[name="signup[OS]"]').length > 0){
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }

  /*********** show image */
  FN.gitCoffee.showImage();

  /*********** Display either Wallpaper+Poster info -OR- sticker giveaway */
  FN.gitCoffee.toggleContentType();

  /************ Show Info Area */
  setTimeout(function(){
    $('.store-content__wrapper').css({'right': '0px'});
    $('.store-content__wrapper .social-button').addClass('social-button--animated');
  }, 1500);

  /*********** newsletter subscription */
  $('.button--signup-revealer').on('click', function(event){
    FN.gitCoffee.showNewsletterSignup();
    event.preventDefault();
  });

  $('.button--stickersignup-revealer').on('click', function(event){
    FN.gitCoffee.showStickerForm();
    event.preventDefault();
  });

  /*********** newsletter subscription */
  $('.' + FN.newsletterConfig.selectors.formClass).each(function(index, element){
    FN.newsletterConfig.instances.push(new FN.newsletter(element));
  });

});
